import { ActionSchema, SideEffectSchema } from "../actions";
import {
  WebAppsSchema,
  WebAppsConst,
  CustomDomainConst,
  CustomDomainSchema,
  MobileAppsConst,
  MobileAppsSchema,
  AddMobileAppsSchema,
  DeploymentConst,
  JSWidgetsConst,
  CustomRegistrationField,
  GetCustomFieldSchema,
  GetRegistarationFieldSchema,
  SMTPSettingSchema,
  VerifySMTPSettingResponseSchema,
  SMTPSettingsConst,
  SaveCustomDomainSchema,
  DeleteCustomDomainSchema,
  AllEmailTemplatesSchema,
  EmailTemplateMutationSchema,
  EmailTemplateSettingsSchema,
  GenerateEmailTemplateAISchema
} from "../actions/deploymentActions";
import { combineReducers } from "redux";
import { ProgressiveProfilingDataSlice, ProgressiveProfilingDataState } from "../features/branding/progressiveProfiling";
import smtpSettingsReducer, { SMTPSettingsState } from "../features/branding/smtpSettings";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../services/analytics/tracking";

const withRequestTracking = <T extends object>(state: T, action: ActionSchema<any>) => ({
  ...state,
  ...getRequestTrackingState(action as any)
});

const withSuccessTracking = <T extends object>(state: T, action: ActionSchema<any>) => ({
  ...state,
  ...action.payload,
  ...getOutcomeTrackingState(state as MutationTrackingState, "success")
});

const withErrorTracking = <T extends object>(state: T, action: ActionSchema<any>) => ({
  ...state,
  ...action.payload,
  ...getOutcomeTrackingState(state as MutationTrackingState, "error")
});

//Reducers
const optionalCaptchaReducer = (state = {}, action: ActionSchema<any>) => {
  switch (action.type) {
    case JSWidgetsConst.UPDATE_OPTIONAL_CAPTCHA_LOADING:
    case JSWidgetsConst.UPDATE_OPTIONAL_CAPTCHA_SUCCESS:
    case JSWidgetsConst.UPDATE_OPTIONAL_CAPTCHA_ERROR:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

const updateDataSchemaProps = (state = {}, action: ActionSchema<any>) => {
  switch (action.type) {
    case CustomRegistrationField.UPDATE_DATASCHEMA_FIELDS_DATA:
    case CustomRegistrationField.UPDATE_DATASCHEMA_FIELDS_DATA_SUCCESS: {
      return {
        ...state,
        ...action.payload
      };
    }
    default:
      return state;
  }
};
const platformFieldSettingReducer = (state = {}, action: ActionSchema<any>) => {
  switch (action.type) {
    case CustomRegistrationField.GET_PLATFORM_FIELD_LOADING:
    case CustomRegistrationField.GET_PLATFORM_FIELD_SUCCESS:
    case CustomRegistrationField.GET_PLATFORM_FIELD_ERROR:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};
const registrationFormsCustomeFieldSettingReducer = (state = {}, action: ActionSchema<any>) => {
  switch (action.type) {
    case CustomRegistrationField.GET_CUSTOM_FIELD_LOADING:
    case CustomRegistrationField.GET_CUSTOM_FIELD_SUCCESS:
    case CustomRegistrationField.GET_CUSTOM_FIELD_ERROR:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};
const registrationFormsRegistrationFieldSettingReducer = (state = {}, action: ActionSchema<any>) => {
  switch (action.type) {
    case CustomRegistrationField.GET_REGISTRATION_FORMS_FIELD_LOADING:
    case CustomRegistrationField.GET_REGISTRATION_FORMS_FIELD_SUCCESS:
    case CustomRegistrationField.GET_REGISTRATION_FORMS_FIELD_ERROR:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};
const platformRegistrationFieldSettingReducer = (state = {}, action: ActionSchema<any>) => {
  switch (action.type) {
    case CustomRegistrationField.POST_PLATFORM_FIELD_LOADING:
    case CustomRegistrationField.POST_PLATFORM_FIELD_SUCCESS:
    case CustomRegistrationField.POST_PLATFORM_FIELD_ERROR:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

const webAppsReducer = (state = {}, action: ActionSchema<WebAppsSchema>) => {
  switch (action.type) {
    case WebAppsConst.GET_WEB_APPS_LOADING:
    case WebAppsConst.GET_WEB_APPS_SUCCESS:
    case WebAppsConst.GET_WEB_APPS_ERROR:
    case WebAppsConst.ADD_WEB_APPS_LOADING:
    case WebAppsConst.ADD_WEB_APPS_SUCCESS:
    case WebAppsConst.ADD_WEB_APPS_ERROR:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

const customDomainReducer = (state = {}, action: ActionSchema<CustomDomainSchema>) => {
  switch (action.type) {
    case CustomDomainConst.GET_CUSTOM_DOMAIN_LOADING:
    case CustomDomainConst.GET_CUSTOM_DOMAIN_SUCCESS:
    case CustomDomainConst.GET_CUSTOM_DOMAIN_ERROR:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};
const saveCustomDomainReducer = (state = {}, action: ActionSchema<SaveCustomDomainSchema>) => {
  switch (action.type) {
    case CustomDomainConst.SAVE_CUSTOM_DOMAIN:
      return withRequestTracking(state, action);
    case CustomDomainConst.SAVE_CUSTOM_DOMAIN_LOADING:
      return { ...state, ...action.payload };
    case CustomDomainConst.SAVE_CUSTOM_DOMAIN_SUCCESS:
      return withSuccessTracking(state, action);
    case CustomDomainConst.SAVE_CUSTOM_DOMAIN_ERROR:
      return withErrorTracking(state, action);
    default:
      return state;
  }
};

const deleteCustomDomainReducer = (state = {}, action: ActionSchema<DeleteCustomDomainSchema>) => {
  switch (action.type) {
    case CustomDomainConst.DELETE_CUSTOM_DOMAIN:
      return withRequestTracking(state, action);
    case CustomDomainConst.DELETE_CUSTOM_DOMAIN_LOADING:
      return { ...state, ...action.payload };
    case CustomDomainConst.DELETE_CUSTOM_DOMAIN_SUCCESS:
      return withSuccessTracking(state, action);
    case CustomDomainConst.DELETE_CUSTOM_DOMAIN_ERROR:
      return withErrorTracking(state, action);
    default:
      return state;
  }
};

const getmobileAppsReducer = (state = {}, action: ActionSchema<MobileAppsSchema>) => {
  switch (action.type) {
    case MobileAppsConst.GET_MOBILE_APPS_SOTT_LOADING:
    case MobileAppsConst.GET_MOBILE_APPS_SOTT_ERROR:
    case MobileAppsConst.GET_MOBILE_APPS_SOTT_SUCCESS:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

const addmobileAppsReducer = (state = {}, action: ActionSchema<MobileAppsSchema>) => {
  switch (action.type) {
    case MobileAppsConst.ADD_MOBILE_APPS_SOTT_LOADING:
    case MobileAppsConst.ADD_MOBILE_APPS_SOTT_ERROR:
    case MobileAppsConst.ADD_MOBILE_APPS_SOTT_SUCCESS:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};
const getSMTPSettingsReducer = (state = {}, action: ActionSchema<SMTPSettingSchema>) => {
  switch (action.type) {
    case DeploymentConst.GET_SMTP_SETTINGS_LOADING:
    case DeploymentConst.GET_SMTP_SETTINGS_ERROR:
    case DeploymentConst.GET_SMTP_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

const saveSMTPSettingsReducer = (state = {}, action: ActionSchema<SMTPSettingSchema>) => {
  switch (action.type) {
    case SMTPSettingsConst.SAVE_SMTP_SETTINGS_LOADING:
    case SMTPSettingsConst.SAVE_SMTP_SETTINGS_ERROR:
    case SMTPSettingsConst.SAVE_SMTP_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};
const verifySMTPSettingsReducer = (state = {}, action: ActionSchema<VerifySMTPSettingResponseSchema>) => {
  switch (action.type) {
    case SMTPSettingsConst.VERIFY_SMTP_SETTINGS_LOADING:
    case SMTPSettingsConst.VERIFY_SMTP_SETTINGS_ERROR:
    case SMTPSettingsConst.VERIFY_SMTP_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};

const allEmailTemplatesReducer = (state = {}, action: ActionSchema<AllEmailTemplatesSchema>) => {
  switch (action.type) {
    case DeploymentConst.GET_ALL_EMAIL_TEMPLATES_LOADING:
    case DeploymentConst.GET_ALL_EMAIL_TEMPLATES_SUCCESS:
    case DeploymentConst.GET_ALL_EMAIL_TEMPLATES_ERROR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const emailTemplateMutationReducer = (state = {}, action: ActionSchema<EmailTemplateMutationSchema>) => {
  switch (action.type) {
    case DeploymentConst.CREATE_EMAIL_TEMPLATE:
    case DeploymentConst.UPDATE_EMAIL_TEMPLATE:
    case DeploymentConst.DELETE_EMAIL_TEMPLATE:
    case DeploymentConst.RESET_EMAIL_TEMPLATE:
      return withRequestTracking(state, action);
    case DeploymentConst.CREATE_EMAIL_TEMPLATE_LOADING:
    case DeploymentConst.UPDATE_EMAIL_TEMPLATE_LOADING:
    case DeploymentConst.DELETE_EMAIL_TEMPLATE_LOADING:
    case DeploymentConst.RESET_EMAIL_TEMPLATE_LOADING:
      return { ...state, ...action.payload };
    case DeploymentConst.CREATE_EMAIL_TEMPLATE_SUCCESS:
    case DeploymentConst.UPDATE_EMAIL_TEMPLATE_SUCCESS:
    case DeploymentConst.DELETE_EMAIL_TEMPLATE_SUCCESS:
    case DeploymentConst.RESET_EMAIL_TEMPLATE_SUCCESS:
      return withSuccessTracking(state, action);
    case DeploymentConst.CREATE_EMAIL_TEMPLATE_ERROR:
    case DeploymentConst.UPDATE_EMAIL_TEMPLATE_ERROR:
    case DeploymentConst.DELETE_EMAIL_TEMPLATE_ERROR:
    case DeploymentConst.RESET_EMAIL_TEMPLATE_ERROR:
      return withErrorTracking(state, action);
    case DeploymentConst.RESET_EMAIL_TEMPLATE_MUTATION_STATE:
      return {};
    default:
      return state;
  }
};

const emailSettingsReducer = (state = {}, action: ActionSchema<EmailTemplateSettingsSchema>) => {
  switch (action.type) {
    case DeploymentConst.GET_EMAIL_SETTINGS_LOADING:
    case DeploymentConst.GET_EMAIL_SETTINGS_SUCCESS:
    case DeploymentConst.GET_EMAIL_SETTINGS_ERROR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const saveEmailSettingsReducer = (state = {}, action: ActionSchema<EmailTemplateSettingsSchema>) => {
  switch (action.type) {
    case DeploymentConst.SAVE_EMAIL_SETTINGS:
      return withRequestTracking(state, action);
    case DeploymentConst.SAVE_EMAIL_SETTINGS_LOADING:
      return { ...state, ...action.payload };
    case DeploymentConst.SAVE_EMAIL_SETTINGS_SUCCESS:
      return withSuccessTracking(state, action);
    case DeploymentConst.SAVE_EMAIL_SETTINGS_ERROR:
      return withErrorTracking(state, action);
    case DeploymentConst.RESET_SAVE_EMAIL_SETTINGS_STATE:
      return {};
    default:
      return state;
  }
};

const sendTestEmailReducer = (state = {}, action: ActionSchema<SideEffectSchema>) => {
  switch (action.type) {
    case DeploymentConst.SEND_TEST_EMAIL_TEMPLATE:
      return withRequestTracking(state, action);
    case DeploymentConst.SEND_TEST_EMAIL_TEMPLATE_LOADING:
      return { ...state, ...action.payload };
    case DeploymentConst.SEND_TEST_EMAIL_TEMPLATE_SUCCESS:
      return withSuccessTracking(state, action);
    case DeploymentConst.SEND_TEST_EMAIL_TEMPLATE_ERROR:
      return withErrorTracking(state, action);
    case DeploymentConst.RESET_SEND_TEST_EMAIL_STATE:
      return {};
    default:
      return state;
  }
};

const generateEmailTemplateAIReducer = (state = {}, action: ActionSchema<GenerateEmailTemplateAISchema>) => {
  switch (action.type) {
    case DeploymentConst.GENERATE_EMAIL_TEMPLATE_AI:
      return withRequestTracking(state, action);
    case DeploymentConst.GENERATE_EMAIL_TEMPLATE_AI_LOADING:
      return { ...state, ...action.payload };
    case DeploymentConst.GENERATE_EMAIL_TEMPLATE_AI_SUCCESS:
      return withSuccessTracking(state, action);
    case DeploymentConst.GENERATE_EMAIL_TEMPLATE_AI_ERROR:
      return withErrorTracking(state, action);
    case DeploymentConst.RESET_GENERATE_EMAIL_TEMPLATE_AI_STATE:
      return {};
    default:
      return state;
  }
};

// Combine Schemas
export interface DeploymentSchema {
  webApps: WebAppsSchema;
  customDomain: CustomDomainSchema;
  getmobileApps: MobileAppsSchema;
  addmobileApps: AddMobileAppsSchema;
  customFieldCollection: GetCustomFieldSchema;
  registrationFieldCollection: GetRegistarationFieldSchema;
  platformFieldSetting: GetRegistarationFieldSchema;
  platformFiled: GetRegistarationFieldSchema;
  optionCaptchaSetting: any;
  verifySMTPSettingsStatus: VerifySMTPSettingResponseSchema;
  dataSchemaFields: any;
  saveCustomDomain: SaveCustomDomainSchema;
  deleteCustomDomain: DeleteCustomDomainSchema;
  progressiveProfilingData: ProgressiveProfilingDataState;
  smtpSetting: SMTPSettingsState;

  allEmailTemplates: AllEmailTemplatesSchema;
  emailTemplateMutation: EmailTemplateMutationSchema;
  emailSettings: EmailTemplateSettingsSchema;
  saveEmailSettings: EmailTemplateSettingsSchema;
  sendTestEmail: SideEffectSchema;
  generateEmailTemplateAI: GenerateEmailTemplateAISchema;
}

// Combine Reducers
const deploymentReducer = combineReducers({
  webApps: webAppsReducer,
  customDomain: customDomainReducer,
  getmobileApps: getmobileAppsReducer,
  addmobileApps: addmobileAppsReducer,
  customFieldCollection: registrationFormsCustomeFieldSettingReducer,
  registrationFieldCollection: registrationFormsRegistrationFieldSettingReducer,
  optionCaptchaSetting: optionalCaptchaReducer,
  platformFieldSetting: platformFieldSettingReducer,
  smtpSettings: getSMTPSettingsReducer,
  saveSMTPSettingsStatus: saveSMTPSettingsReducer,
  verifySMTPSettingsStatus: verifySMTPSettingsReducer,
  platformFiled: platformRegistrationFieldSettingReducer,
  dataSchemaFields: updateDataSchemaProps,
  saveCustomDomain: saveCustomDomainReducer,
  deleteCustomDomain: deleteCustomDomainReducer,
  progressiveProfilingData: ProgressiveProfilingDataSlice.reducer,
  smtpSetting: smtpSettingsReducer,

  allEmailTemplates: allEmailTemplatesReducer,
  emailTemplateMutation: emailTemplateMutationReducer,
  emailSettings: emailSettingsReducer,
  saveEmailSettings: saveEmailSettingsReducer,
  sendTestEmail: sendTestEmailReducer,
  generateEmailTemplateAI: generateEmailTemplateAIReducer
});

export default deploymentReducer;
